module.exports = __webpack_public_path__ + "fonts/PT-Mono-Bold.7b81dea.ttf";